// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import api from "@/api/index.js"; // 全局挂载请求
import { tool } from "@/utils/tool.js"; // 全局挂载请求
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        title: sessionStorage.getItem('title') ? sessionStorage.getItem('title') : '',
        color: sessionStorage.getItem('color') ? sessionStorage.getItem('color') : '',
        menuData: sessionStorage.getItem('menuData') ? sessionStorage.getItem('menuData') : [],
        config: sessionStorage.getItem('config') ? JSON.parse(sessionStorage.getItem('config')) : null,
    },
    mutations: {
        setTitle(state, value) {
            state.title = value;
        },
        setColor(state, value) {
            state.color = value;
        },
        setMenuData(state, value) {
            state.menuData = value;
        },
        setConfig(state, value) {
            state.config = value;
        },
    },
    actions: {
        async increment({ commit }, route) {
            let projectId = sessionStorage.getItem('projectId')
            if (!projectId) {
                return
            }
            let res = await api.getprojectinfo({ Id: projectId });
            if (res.code == 200 || res.code == 204) {
                sessionStorage.setItem("title", res.data ? sessionStorage.getItem('language') == 'en' ? res.data.en_title : res.data.cn_title : '');
                sessionStorage.setItem("status", res.data ? res.data.status : '');
                commit('setTitle', res.data ? res.data.cn_title : '');
                document.title = res.data ? sessionStorage.getItem('language') == 'en' ? res.data.en_title : res.data.cn_title : '';
            }
            let res2 = await api.getprojectconfiginfo({ projectId: projectId, key: "basic", });
            if (res2.code == 200 || res2.code == 204) {
                let data = res2.data.typevalue
                let dataJson = JSON.parse(res2.data.typevalue)
                let menuData = res2.data ? tool.menuArray(JSON.parse(res2.data.typevalue)) : [];

                if (!menuData.find(item => item.path == route) && route != 'login') {
                    router.push({ name: '404' })
                }
                if (sessionStorage.getItem('language') == "en") {
                    if (dataJson.setForm) {
                        dataJson.setForm.logintype = ["email"]
                        dataJson.setForm.regtype = ["emailvalidate"]
                        data = JSON.stringify(dataJson)
                    }
                }
                sessionStorage.setItem("menuData", JSON.stringify(menuData));
                sessionStorage.setItem("config", res2.data ? data : '');

                let color = dataJson.setForm.colorPrimary
                    ? dataJson.setForm.colorPrimary
                    : "#026ABB";
                sessionStorage.setItem("color", color);
                commit('setColor', color);
                commit('setMenuData', menuData);
                commit('setConfig', JSON.parse(data));
            }

            if (res.data.status == 2) {
                router.push({
                    name: 'end',
                    query: {
                        projectId: projectId,
                    },
                })
            }

        }
    },
    getters: {
        count: state => state.count
    }
});
